// -------------订单管理-------------
//订单记录
export const orderrecord = {
  path: '/orderrecord',
  name: 'orderrecord',
  id:11,
  component: () => import('@/page/finance/orderList.vue'),
  meta: [
    'add',
    'search'
  ]
}
//退单记录
export const returnrecord = {
  path: '/returnrecord',
  name: 'returnrecord',
  id:11,
  component: () => import('@/page/finance/returnrecord.vue'),
  meta: [
    'add',
    'search'
  ]
}
export const financialSettlement = {
  path: '/financialSettlement',
  name: 'financialSettlement',
  id:11,
  component: () => import('@/page/finance/charts.vue'),
  meta: [
    'add',
    'search'
  ]
}
//--------------业务管理--------------
//会员卡管理
export const card = {
  path: '/card',
  name: 'card',
  id:11,
  component: () => import('@/page/members/card.vue'),
  meta: [
    'add',
    'search'
  ]
}
//充值管理
export const prepaid = {
  path: '/prepaid',
  name: 'prepaid',
  id:11,
  component: () => import('@/page/members/prepaid.vue'),
  meta: [
    'add',
    'search'
  ]
}
//-------------审核管理-------------
//广告管理
export const adver = {
  path: '/adver',
  name: 'adver',
  id:11,
  component: () => import('@/page/information/adver.vue'),
  meta: [
    'add',
    'search'
  ]
}
//公告管理
export const notice = {
  path: '/notice',
  name: 'notice',
  id:11,
  component: () => import('@/page/information/notice.vue'),
  meta: [
    'add',
    'search'
  ]
}
//监控管理
export const control = {
  path: '/control',
  name: 'control',
  id:11,
  component: () => import('@/page/information/control.vue'),
  meta: [
    'add',
    'search'
  ]
}
// ---------------------用户管理-----------------
// 普通用户管理
export const user = {
  path: '/user',
  name: 'user',
  component: () => import('@/page/user/user/userIndex.vue'),
  meta: []
}
// 咨询师管理
export const consultant = {
  path: '/consultant',
  name: 'consultant',
  component: () => import('@/page/user/consultant/consultantIndex.vue'),
  meta: []
}
// 导诊管理
export const guide = {
  path: '/guide',
  name: 'guide',
  component: () => import('@/page/user/guide/guideIndex.vue'),
  meta: []
}
// 医院管理
export const hospital = {
  path: '/hospital',
  name: 'hospital',
  component: () => import('@/page/user/hospital.vue'),
  meta: []
}

// ---------------------系统管理-----------------
// 标签管理
export const label = {
  path: '/label',
  name: 'label',
  component: () => import('@/page/system/label/labelIndex.vue'),
  meta: []
}
export const serviceTag = {
  path: '/serviceTag',
  name: 'serviceTag',
  component: () => import('@/page/system/serviceTag/serviceTagIndex.vue'),
  meta: []
}
export const virtualUser = {
  path: '/virtualUser',
  name: 'virtualUser',
  component: () => import('@/page/system/virtualUser/virtualUser.vue'),
  meta: []
}
export const systemControl = {
  path: '/systemControl',
  name: 'systemControl',
  component: () => import('@/page/system/system.vue'),
  meta: []
}

export const postReview = {
  path: '/postReview',
  name: 'postReview',
  component: () => import('@/page/review/post/postReviewIndex.vue'),
  meta: []
}

export const consultantReview = {
  path: '/consultantReview',
  name: 'consultantReview',
  component: () => import('@/page/review/consultant/consultantReviewIndex.vue'),
  meta: []
}
export const salesPerson = {
  path: '/salesPerson',
  name: 'salesPerson',
  component: () => import('@/page/sales/salesPerson.vue'),
  meta: []
}
export const performance = {
  path: '/performance',
  name: 'performance',
  component: () => import('@/page/sales/performance.vue'),
  meta: []
}



// WEBPACK FOOTER //
// ./src/router/export.js